import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import classNames from 'classnames'

import styleTerms from '../term-and-condition/term-and-condition.module.scss'
import style from './imprint.module.scss'

import { StaticLayout as Layout } from '../../../component'
import helper from '../term-and-condition/helper/term-and-condition.helper'

/**
 * Render Imprint screen.
 */
export const Index = ({ data, pageContext: { noHeader } }) => {
    const { html } = helper.treatFiles(data)

    return (
        <Layout>
            <div
                className={classNames(styleTerms.wrapper, 'page-wrapper', {
                    [style.wrapperNoHeader]: noHeader,
                })}
            >
                <div
                    className="html"
                    // eslint-disable-next-line
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            </div>
        </Layout>
    )
}

Index.propTypes = {
    data: PropTypes.object.isRequired,
    pageContext: PropTypes.object.isRequired,
}

const Imprint = Index

export default Imprint

/**
 * Retrieve document with the content of the page
 * @param {string} locale - the locale of the page
 */
export const query = graphql`
    query($regex: String!) {
        allMarkdownRemark(filter: { fileAbsolutePath: { regex: $regex } }) {
            edges {
                node {
                    html
                    headings {
                        value
                        depth
                    }
                }
            }
        }
    }
`
